var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { widgetMetricTableColMetricPeriodDiffWorkPatternsStyle, widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { TablesDiffColorsConfig } from '@web/config';
import { classNames } from '@web/utility';
import { formatDuration } from '@workalizer/shared/utils';
var metricValueCol = __assign(__assign({}, widgetMetricTableColMetricValueStyle), { minWidth: '2.75rem' });
var durationValueCol = {
    width: '1%',
    minWidth: '7rem'
};
var periodDiffCol = widgetMetricTableColMetricPeriodDiffWorkPatternsStyle;
var teamMetricColgroup = [
    durationValueCol,
    periodDiffCol,
    metricValueCol,
    periodDiffCol
];
export var meetAnalyticTableColgroup = function (options) {
    var _a;
    var includeTeamMetrics = (_a = options === null || options === void 0 ? void 0 : options.includeTeamMetrics) !== null && _a !== void 0 ? _a : true;
    return __spreadArray([
        { width: '16%', minWidth: '8rem' },
        metricValueCol,
        periodDiffCol,
        metricValueCol,
        periodDiffCol,
        durationValueCol,
        periodDiffCol
    ], (includeTeamMetrics ? teamMetricColgroup : []), true);
};
var buildMeetAnalyticMetricPairCells = function (rowKey, metricId, valueDisplay, diff, valueTdClass, onNavigate) {
    if (valueTdClass === void 0) { valueTdClass = widgetMetricTableValueTdClass; }
    return [
        {
            id: "".concat(rowKey, "-").concat(metricId, "-value"),
            className: classNames(valueTdClass, onNavigate && 'cursor-pointer'),
            render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, onNavigate && 'cursor-pointer'), onClick: onNavigate }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: valueDisplay })) }))); }
        },
        metricTablePeriodDiffRowCell("".concat(rowKey, "-").concat(metricId, "-period"), diff, TablesDiffColorsConfig.GREEN)
    ];
};
export var buildMeetAnalyticTableColumns = function (t, i18nPrefix, options) {
    var _a;
    var includeTeamMetrics = (_a = options === null || options === void 0 ? void 0 : options.includeTeamMetrics) !== null && _a !== void 0 ? _a : true;
    var headerClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var metricColspan = 2;
    var columnKeys = __spreadArray([
        'parameter',
        'shareOfMeetings',
        'count',
        'duration'
    ], (includeTeamMetrics ? ['manHours', 'avgParticipants'] : []), true);
    return columnKeys.map(function (columnKey) { return ({
        title: t("".concat(i18nPrefix, ".columns.").concat(columnKey)),
        isVisible: true,
        colspan: columnKey === 'parameter' ? undefined : metricColspan,
        className: headerClass
    }); });
};
export var buildMeetAnalyticTableRow = function (rowKey, row, labelContent, onNavigate, options) {
    var _a;
    var includeTeamMetrics = (_a = options === null || options === void 0 ? void 0 : options.includeTeamMetrics) !== null && _a !== void 0 ? _a : true;
    var durationValueTdClass = "".concat(widgetMetricTableValueTdClass, " overflow-hidden");
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            id: "".concat(rowKey, "-parameter"),
            className: classNames(widgetMetricTablePrimaryLabelTdClass, onNavigate && 'cursor-pointer'),
            render: function () { return (_jsx("div", __assign({ className: onNavigate ? 'cursor-pointer' : undefined, onClick: onNavigate }, { children: labelContent }))); }
        }
    ], buildMeetAnalyticMetricPairCells(rowKey, 'share', "".concat(row.shareOfMeetings.current, "%"), row.shareOfMeetings.previous, widgetMetricTableValueTdClass, onNavigate), true), buildMeetAnalyticMetricPairCells(rowKey, 'count', String(row.meetingCount.current), row.meetingCount.previous, widgetMetricTableValueTdClass, onNavigate), true), buildMeetAnalyticMetricPairCells(rowKey, 'duration', formatDuration(row.durationSeconds.current, 'seconds'), row.durationSeconds.previous, durationValueTdClass, onNavigate), true), (includeTeamMetrics && row.manHoursSeconds && row.avgParticipants
        ? __spreadArray(__spreadArray([], buildMeetAnalyticMetricPairCells(rowKey, 'manHours', formatDuration(row.manHoursSeconds.current, 'seconds'), row.manHoursSeconds.previous, durationValueTdClass, onNavigate), true), buildMeetAnalyticMetricPairCells(rowKey, 'avgParticipants', row.avgParticipants.current.toFixed(1), row.avgParticipants.previous, widgetMetricTableValueTdClass, onNavigate), true) : []), true);
};
export function buildMeetAnalyticTableData(_a) {
    var keys = _a.keys, rowsByKey = _a.rowsByKey, getLabel = _a.getLabel, getFilters = _a.getFilters, navigateToMeetSearch = _a.navigateToMeetSearch, _b = _a.includeTeamMetrics, includeTeamMetrics = _b === void 0 ? true : _b;
    return keys.map(function (key) {
        var onNavigate = function () { return navigateToMeetSearch(getFilters === null || getFilters === void 0 ? void 0 : getFilters(key)); };
        return buildMeetAnalyticTableRow(key, rowsByKey[key], _jsx("div", __assign({ className: "min-w-0 max-w-full break-words text-gray-900" }, { children: getLabel(key) })), onNavigate, { includeTeamMetrics: includeTeamMetrics });
    });
}
export var buildMeetAnalyticCsvRow = function (t, i18nPrefix, rowLabel, row, options) {
    var _a, _b;
    var _c;
    var includeTeamMetrics = (_c = options === null || options === void 0 ? void 0 : options.includeTeamMetrics) !== null && _c !== void 0 ? _c : true;
    return __assign((_a = {}, _a[t("".concat(i18nPrefix, ".columns.parameter"))] = rowLabel, _a[t("".concat(i18nPrefix, ".columns.shareOfMeetings"))] = "".concat(row.shareOfMeetings.current, "%"), _a[t("".concat(i18nPrefix, ".columns.count"))] = row.meetingCount.current, _a[t("".concat(i18nPrefix, ".columns.duration"))] = formatDuration(row.durationSeconds.current, 'seconds'), _a), (includeTeamMetrics &&
        row.manHoursSeconds &&
        row.avgParticipants && (_b = {},
        _b[t("".concat(i18nPrefix, ".columns.manHours"))] = formatDuration(row.manHoursSeconds.current, 'seconds'),
        _b[t("".concat(i18nPrefix, ".columns.avgParticipants"))] = row.avgParticipants.current,
        _b)));
};
